var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"custom":"","to":_vm.to || 'false'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var navigate = ref.navigate;
return [_c('a',{ref:"link",staticClass:"ui-btn-link",on:{"click":function (e) {
        _vm._onClick(e, navigate)
      }}},[_c('span',{ref:"content",staticClass:"content"},[_vm._t("default")],2)])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }